import ProgressIndicator from '@/components/ProgressIndicator';
import s from './HelpCenterIframe.module.scss';

const HelpCenterIframe: React.FC = () => (
  <div className={s.helpCenterContainer}>
    <ProgressIndicator className={s.progress} />
    <iframe src="https://glade.frontkb.com/en" className={s.helpCenterIframe} />
  </div>
);

export default HelpCenterIframe;
